export default __webpack_public_path__ + "static/media/back-to-top.ea88f257.svg";